package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class CommonMessageResponse(
    val message: String = "",
    val error: String  = ""
)